import { AttachmentSource } from './model/attachment-source.model';
import { ResourceRequestOptions } from './model/resource-request-options.model';

/**
 * The registered sources the agent allows this turn, in registration order. An agent that sends no `allowed` allows
 * every registered source; an allowed type with no registered source is ignored.
 */
export function resolveAllowedSources(registered: AttachmentSource[], options: ResourceRequestOptions): AttachmentSource[] {
    const allowed = options.allowed;

    if (allowed === undefined) {
        return registered;
    }

    return registered.filter((source) => allowed.includes(source.resourceType));
}
